import React from 'react';

const EnergyCertificateGradeG = props => (
  <svg width="232" height="34" viewBox="0 0 232 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.941311V33.4205H215.593L231.96 17.0553L215.593 0.941311H0Z" fill="#EA2039" />
    <path
      d="M199.638 16.102H210.067V29.5574H206.59L206.07 26.427C204.748 27.9564 202.836 30.2167 198.282 30.2167C192.269 30.2167 186.811 25.9069 186.811 17.1461C186.811 10.3324 190.598 3.8996 199.013 3.93441C206.66 3.93441 209.684 8.9055 209.962 12.3472H204.748C204.748 11.3746 202.975 8.24617 199.289 8.24617C195.571 8.24617 192.13 10.8177 192.13 17.2157C192.13 24.0294 195.85 25.8025 199.394 25.8025C200.54 25.8025 204.367 25.35 205.444 20.3093H199.638V16.102Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeG;
